import { dispatchAction } from "../state/dispatchAction";
import { setBookingList, setLoading } from "../../reducers/configSlice";
import { apiGetDeviceBookingList } from "../../api/actions";

export const fetchDeviceBookingList = async (date = null) => {
    try {
        const result = await apiGetDeviceBookingList(date);

        if (result.error) {
            console.error('Error fetching device booking list:', result.error);
            return false;
        }

        const bookingListResponse = result.response;
        if (bookingListResponse) {
            await handleBookingListResponse(bookingListResponse);
            return true;
        }

        return false;
    } catch (error) {
        console.error('Error fetching device booking list:', error);
        return false;
    }
};

const handleBookingListResponse = async (bookingListResponse) => {
    dispatchAction(setLoading(false));
    dispatchAction(setBookingList(bookingListResponse));
};

export const fetchDeviceBookingListForDate = async (date) => {
    return await fetchDeviceBookingList(date);
};

export default {
    fetchDeviceBookingList,
    fetchDeviceBookingListForDate
};
